import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import { resources, minorLocales } from 'chaika-translation-data';

i18next.use(initReactI18next).init({
    resources,
    debug: false,
    lng: 'ru',
    fallbackLng: 'ru',
});

export { minorLocales };
